<template>
    <v-autocomplete
        v-model="model"
        :items="collection"
        :loading="loading"
        :search-input.sync="textSearch"
        hide-no-data
        :return-object="returnObject"
        :hide-selected="hideSelected"
        :item-text="itemText"
        :item-value="itemValue"
        :label="label"
        :clearable="clearable"
        :disabled="disabled"
        :multiple="multiple"
        :placeholder="placeholder"
        :outlined="outlined"
        :dense="dense"
        :error-messages="errorMessages"
        :hide-details="hideDetails"
        :small-chips="smallChips"
        class="custom-placeholder"
        >


        <template v-slot:append>
            
            <v-tooltip bottom v-if="showAdd">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small icon @click.prevent.stop="openDialogCreate">
                        <v-icon btn color="green darken-1">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Novo</span>
            </v-tooltip>

        </template>

        <!-- Tratando o slot que mostra o texto do campo -->
        <template v-slot:selection="{ item, index }">

            <span v-if="index === 0">{{ item[itemText] }}</span>
            <span v-if="index === 1" class="grey--text caption ml-1">(+{{ model.length - 1 }} outros)</span>

        </template>

    </v-autocomplete>
    
</template>

<script>
export default {
    name: "FormAutocomplete",
    props: {
        //Propriedades de dados
        value: { type: [String, Number, Object, Array] },
        items: { type: Array },
        item: { type: [Object, Array], required: false },
        search: { type: String },
        errorMessages: { type: Array, required: false },

        //Propriedades de eventos
        loading: { type: Boolean, default: false },
        clearable: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        multiple: { type: Boolean, required: false },

        //Propriedades de configuração
        itemText: { type: String, default: 'name' },
        itemValue: { type: String, default: 'id' },
        label: { type: String, required: false },
        placeholder: { type: String, default: "Comece a digitar para pesquisar"},
        outlined: { type: Boolean, required: false },
        dense: { type: Boolean, required: false },
        hideDetails: { type: [Boolean, String], default: 'auto' },
        smallChips: { type: Boolean, required: false },
        showAdd: { type: Boolean, required: false },
        hideSelected: { type: Boolean, required: false },
        returnObject: { type: Boolean, required: false },

    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        collection: {
            get() {
                if(this.items.length > 0) {
                    return this.items
                } else {

                    if(Array.isArray(this.item)) {
                        return this.item
                    }

                    return [this.item]
                    
                }
            },
            set(val) {
                this.$emit('update:items', val)
            }
        },
        textSearch: {
            get() {
                return this.search
            },
            set(val) {

                if(!val) return

                this.$emit('update:search', val)
            }
        }
    },
    methods: {
        openDialogCreate() {
            this.$emit('onShowFormCreate', true)
            this.collection = []
            this.model = null
        }

    }
}
</script>